import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { REDUCER_NAME } from 'src/reducers/employees/employees';
import { getItem } from 'src/reducers/common/itemReducer';
import selector, { getOptionLabel, display, employeeDisplay, currency, numberWithComma, decimalPlace2 } from 'src/utils/Utils';
import { getRadioOptions } from 'src/reducers/selectOptions';
import { SOCIAL_SECURITY_TARGETS } from 'src/constants/Options';
import { toDisplayFormat } from 'src/utils/Completion';
import tableStyles from '../styles/GeneralTableInfo.scss';
import socialSecurityStyles from './SocialSecurityContributionSection.scss';

const SocialSecurityContributionSectionShow = props => {
  const { employeeSsoSetting, employeeSsoRates, ssoRateTypes } = props;
  const { t } = useTranslation();
  const SSO_CALCULATED_FIXED_AMOUNT_TYPE = 'fixed';

  const isSocialSecurityContribution = employeeSsoSetting?.isSocialSecurityContribution ? '1' : '0';
  const nationalityClassification = employeeSsoSetting?.nationalityClassification;

  const ssoRates = employeeSsoRates.filter(rate => rate.employeeType === nationalityClassification).reduce((acc, curItem) => {
    acc[curItem.rateType] = curItem;
    return acc;
  }, {});

  const totals = Object.values(ssoRates).reduce(
    (acc, rate) => ({
      employeeTotal: acc.employeeTotal + Number(rate.contributionRateEmployee || 0),
      employerTotal: acc.employerTotal + Number(rate.contributionRateEmployer || 0)
    }),
    { employeeTotal: 0, employerTotal: 0 }
  );

  return (
    <div>
      <table className={tableStyles.mTablePersonal}>
        <tbody>
          {/* Social Security Contribution */}
          <tr>
            <th>{t('features.Employees.components.SocialSecurityContribution.social_security_contribution')}:</th>
            <td>{display(getOptionLabel(isSocialSecurityContribution)(SOCIAL_SECURITY_TARGETS))}</td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.SocialSecurityContribution.sso_calculated_amount')}:</th>
            <td>
              {employeeSsoSetting?.ssoCalculatedType === SSO_CALCULATED_FIXED_AMOUNT_TYPE
                ? `${currency(numberWithComma(decimalPlace2(employeeSsoSetting?.ssoCalculatedAmount)))}`
                : t('features.Employees.components.PayrollRuleSectionShow.Follow_salary_rules')}
            </td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.SocialSecurityContribution.social_insurance_number')}:</th>
            <td>{employeeDisplay(employeeSsoSetting?.socialInsuranceNumber)}</td>
          </tr>
          <tr>
            <th className="u-pb10">{t('features.Employees.components.SocialSecurityContribution.social_insurance_ratio')}:</th>
            <td />
          </tr>
        </tbody>
      </table>
      <div>
        <table className="m-table-list">
          <thead>
            <tr key="sso-rates-header">
              <th>{t('features.Employees.components.SocialSecurityContribution.insurance_type')}</th>
              <th>{t('features.Employees.components.SocialSecurityContribution.employee_ratio')}</th>
              <th>{t('features.Employees.components.SocialSecurityContribution.employer_ratio')}</th>
            </tr>
          </thead>
          <tbody>
            {ssoRates &&
              ssoRateTypes.map(rateType => {
                const rate = ssoRates[rateType.value];
                return (
                  <tr key={rateType.value}>
                    <td>{rateType.label}</td>
                    <td className={socialSecurityStyles.ratioField}>
                      <span>{toDisplayFormat(rate.contributionRateEmployee)}</span>
                    </td>
                    <td className={socialSecurityStyles.ratioField}>
                      <span>{toDisplayFormat(rate.contributionRateEmployer)}</span>
                    </td>
                  </tr>
                );
              })}
          </tbody>
          <tfoot>
            <tr key="sso-rates-totals">
              <td>{t('features.Employees.components.SocialSecurityContribution.total_ratio')}</td>
              <td className="employee-ratio">
                <span>{`${toDisplayFormat(`${totals.employeeTotal}`)} %`}</span>
              </td>
              <td className="employer-ratio">
                <span>{`${toDisplayFormat(`${totals.employerTotal}`)} %`}</span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  employeeSsoSetting: selector(getItem(REDUCER_NAME, state), 'employeeSsoSetting'),
  employee: selector(getItem(REDUCER_NAME, state), 'employee'),
  employeeSsoRates: selector(getItem(REDUCER_NAME, state), 'employeeSsoRates'),
  ssoRateTypes: getRadioOptions(state, 'ssoRateTypes')
});

export default connect(mapStateToProps)(SocialSecurityContributionSectionShow);
